// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#auth-signup {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 40px 0;\n}\n\n#auth-signup #contents {\n  width: 100%;\n  max-width: 480px;\n  padding: 15px;\n  margin: auto;\n}\n\n", ""]);
// Exports
module.exports = exports;
